import request from "@/utils/request";

const api = {
  materialList: "/pano/dir", 
  delMaterial: "pano/softDelete",
  delMaterialAll: "pano/softDeleteAll",
  rename: "pano/rename",
  createFolder: "pano/saveOrUpdate",
  recycleList: "pano/recycle",
  recycleDelete: "pano/deleteInfo",
  recycleRegain: "pano/regain",
  getAllDirList: "pano/getAllDir",
  getFolderDepth: "pano/getParentInfo",
  moveDir: "pano/moveDir",
  uploadMaterial: "pano/doAdd",
  replacePano: "pano/addpano",
  materialCategorysList: "material/pageList", 

  auditMaterialList: "material/list",
  auditMaterial: "material/audit",
  addPano:"/pano/addpano",
  loadBar:"/pano/asyncList",
  deleteAsync:"/pano/deleteAsync",//删除正在上传
};

export default api;

export function getMaterialList(data) {
  return request({
    url: api.materialList,
    method: "post",
    data,
  });
}

export function delMaterial(data) {
  return request({
    url: api.delMaterial,
    method: "post",
    data,
  });
}

export function delMaterialAll() {
  return request({
    url: api.delMaterialAll,
    method: "post"
  });
}

export function rename(data) {
  return request({
    url: api.rename,
    method: "post",
    data,
  });
}
export function createFolder(data) {
  return request({
    url: api.createFolder,
    method: "post",
    data,
  });
}
export function getRecycleList(data) {
  return request({
    url: api.recycleList,
    method: "post",
    data,
  });
}
export function recycleDel(data) {
  return request({
    url: api.recycleDelete,
    method: "post",
    data,
  });
}
export function recycleRegain(data) {
  return request({
    url: api.recycleRegain,
    method: "post",
    data,
  });
}
export function getTreeDir(data) {
  return request({
    url: api.getAllDirList,
    method: "post",
    data,
  });
}
export function getFolderDepth(data) {
  return request({
    url: api.getFolderDepth,
    method: "post",
    data,
  });
}
export function moveDir(data) {
  return request({
    url: api.moveDir,
    method: "post",
    data,
  });
}
export function uploadMaterial(data) {
  return request({
    url: api.uploadMaterial,
    method: "post",
    data,
  });
}

export function auditMaterialList(data) {
  return request({
    url: api.auditMaterialList,
    method: "post",
    data,
  });
}
export function auditMaterial(data) {
  return request({
    url: api.auditMaterial,
    method: "post",
    data,
  });
}


export function materialCategorysList(data) {
  return request({
    url: api.materialCategorysList,
    method: "post",
    data,
  });
}

export function addPano(data) {
  return request({
    url: api.addPano,
    method: "post",
    data,
  });
}
export function replacePano(data) {
  return request({
    url: api.replacePano,
    method: "post",
    data,
  });
}
export function loadBar() {
  return request({
    url: api.loadBar,
    method: "post",
  });
}
export function deleteAsync(data) {
  return request({
    url: api.deleteAsync,
    method: "post",
    data,
  });
}